module.exports = __webpack_public_path__ + "img/map.55b42af0.gif";